
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/api/zoom",
      function () {
        return require("private-next-pages/material-ui/api/zoom.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/api/zoom"])
      });
    }
  